import Header from './Header';
import { Outlet } from 'react-router-dom';
import styles from './Layout.module.css';
import Footer from './Footer';

const Layout = () => (
  <div className={styles.page}>
    <Header />
    <main className={styles.main}>
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default Layout;
